import { I18nextContext, useTranslation } from 'gatsby-plugin-react-i18next';
import React, { useContext } from 'react';

import Layout from '../Layout';
import Seo from '../Seo';
import ReferALandlordFaq from './ReferALandlordFaq';
import ReferALandlordHeader from './ReferALandlordHeader';
import ReferALandlordHowTo from './ReferALandlordHowTo';
import ReferALandlordIntro from './ReferALandlordIntro';

const ReferALandlord = (): JSX.Element => {
  const { language } = useContext(I18nextContext);
  const { t } = useTranslation();

  return (
    <Layout
      customHeader={<ReferALandlordHeader />}
      user="landlord"
      isReferralLayout={true}
    >
      <Seo
        canonical={`/${language}/refer-a-landlord`}
        hreflang={language}
        title={t('seo:titleReferALandlord')}
        description={t('seo:descriptionReferALandlord')}
        ogImageUrl={`${process.env.GATSBY_CDN_URL}/opengraph/zappyrent-logo-purple-500x500.png`}
        ogImageHeight="500"
        ogImageWidth="500"
      />
      <article>
        <ReferALandlordIntro />
        <ReferALandlordHowTo />
        <ReferALandlordFaq />
      </article>
    </Layout>
  );
};

export default ReferALandlord;
